import React, { useEffect, useState } from "react";
import { Modal, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { fetchEmployeeOrganizationTree } from "../../core/data/redux/employee/employeeAction";

const UnsignedEmployeesModal: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { employeeHierarchy } = useSelector((state: any) => state.employee);

  useEffect(() => {
    dispatch(fetchEmployeeOrganizationTree());
  }, [dispatch]);

  const unsignedEmployees = employeeHierarchy.filter(
    (e: any) => !e.SupervisorName || e.SupervisorName === ""
  );

  return (
    <>
      {unsignedEmployees.length > 0 && (
        <div
          className="row"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "240px",
            height: "89px",
            background: "#f3f4f6",
            borderRadius: "8px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
            cursor: "pointer",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            transition: "all 0.2s ease",
            textAlign: "center",
            flexDirection: "column",
          }}
          onClick={() => setIsModalOpen(true)}
          onMouseEnter={(e) => (e.currentTarget.style.border = "2px solid #4f46e5")}
          onMouseLeave={(e) => (e.currentTarget.style.border = "1px solid #e5e7eb")}
        >
          <div style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
            Unassigned Employees
          </div>
          <div style={{ fontSize: "12px", color: "#6b7280" }}>
            {unsignedEmployees.length} Employee(s)
          </div>
        </div>
      )}

      <Modal
        title="Unassigned Employees"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={800}
        style={{ top: 80, right: 155, marginLeft: "auto", marginRight: 20 }}
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden", padding: "10px" }}
      >
        <Row gutter={[24, 24]}>
          {unsignedEmployees.map((emp: any) => (
            <Col xs={24} sm={12} md={8} key={emp.EmployeeID}>
              <div
                className="org-card"
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#ffffff",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  padding: "12px 14px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  boxSizing: "border-box",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  gap: "12px",
                  width: "100%",
                }}
                onClick={() => console.log(emp)}
                onMouseEnter={(e) => (e.currentTarget.style.border = "2px solid #4f46e5")}
                onMouseLeave={(e) => (e.currentTarget.style.border = "1px solid #e5e7eb")}
              >
                <img
                  src={emp.PictureURL || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                  alt="profile"
                  style={{
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #f3f4f6",
                    flexShrink: 0,
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    minWidth: 0,
                    flex: 1,
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#111827",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginBottom: "4px",
                    }}
                    title={emp.Name}
                  >
                    {emp.Name}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#6b7280",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={emp.Designation || "No designation"}
                  >
                    {emp.Designation || "No designation"}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Modal>
    </>
  );
};

export default UnsignedEmployeesModal;
